export const contractFieldHelp = {
  company: {
    description: 'Cliente contratante. Define o vínculo comercial e o contexto de atendimento.',
    example: 'selecione a empresa do contrato',
  },
  title: {
    description: 'Nome do contrato como aparece na operação e nos projetos vinculados.',
    example: 'Contrato bTalk — suporte e plataforma 2026',
  },
  code: {
    description: 'Identificador interno. Se vazio, o sistema gera automaticamente.',
    example: 'ctr-btalk-2026',
  },
  status: {
    description: 'Situação atual do contrato. Rascunho até a vigência começar; Ativo enquanto estiver em vigor.',
    example: 'Ativo',
  },
  startDate: {
    description: 'Data de início da vigência, usada em SLAs, projetos e faturamento.',
    example: '01/01/2026',
  },
  endDate: {
    description: 'Data de término da vigência. Deve ser posterior ao início.',
    example: '31/12/2026',
  },
  responseSla: {
    description: 'Prazo máximo para a primeira resposta em chamados deste contrato. Opcional.',
    example: 'SLA resposta 4 horas úteis',
  },
  resolutionSla: {
    description: 'Prazo máximo para resolver chamados deste contrato. Opcional.',
    example: 'SLA resolução 16 horas úteis',
  },
  product: {
    description: 'Produto comercial coberto por este contrato. Opcional se o contrato for genérico.',
    example: 'bTalk — Plataforma de Inteligência Conversacional',
  },
  calendar: {
    description: 'Calendário de horas úteis para calcular SLA. Se vazio, usa o calendário padrão.',
    example: 'Calendário comercial (seg–sex 9h–18h)',
  },
  description: {
    description: 'Escopo resumido, premissas ou condições relevantes do contrato.',
    example: 'Plataforma + 5.000 h de minutagem, suporte em horário comercial',
  },
  welcomeEnabled: {
    description:
      'Se ativo, envia e-mail de boas-vindas quando o status do contrato passar para Ativo.',
    example: 'ligado',
  },
  welcomeEmailTemplate: {
    description: 'Template de boas-vindas. Vazio usa o padrão das configurações.',
    example: 'Boas-vindas VIP',
  },
  csatEnabled: {
    description: 'Se ativo, permite envio de CSAT (automático ou manual) neste contrato.',
    example: 'ligado',
  },
  csatSurveyForm: {
    description:
      'Formulário CSAT (já inclui o e-mail). Vazio usa o do canal e, se não houver, o padrão da organização.',
    example: 'CSAT Premium',
  },
  npsEnabled: {
    description: 'Se ativo, permite envio de NPS neste contrato.',
    example: 'ligado',
  },
  npsSurveyForm: {
    description:
      'Formulário NPS (já inclui o e-mail). Vazio usa o do canal e, se não houver, o padrão da organização.',
    example: 'NPS estratégico',
  },
  npsFrequency: {
    description: 'Periodicidade do NPS. Vazio usa a frequência das configurações.',
    example: 'Mensal',
  },
} as const;
